module.exports = __webpack_public_path__ + "img/create-order-ok.aafec730.svg";